// Applies a TokenSet to document.documentElement as CSS custom properties.
//
// Color values are converted from hex to RGB-triplet form ("250 250 250") so
// Tailwind's <alpha-value> syntax (rgb(var(--color-bg) / 0.5)) works.

import { TokenSet } from './tokens';

function hexToRgbTriplet(hex: string): string {
  const cleaned = hex.replace('#', '');
  const expanded =
    cleaned.length === 3
      ? cleaned.split('').map((c) => c + c).join('')
      : cleaned;
  const r = parseInt(expanded.slice(0, 2), 16);
  const g = parseInt(expanded.slice(2, 4), 16);
  const b = parseInt(expanded.slice(4, 6), 16);
  return `${r} ${g} ${b}`;
}

const colorVarMap: Array<[keyof TokenSet['color'], string]> = [
  ['bg', '--color-bg'],
  ['bgElevated', '--color-bg-elevated'],
  ['panel', '--color-panel'],
  ['border', '--color-border'],
  ['borderStrong', '--color-border-strong'],
  ['text', '--color-text'],
  ['text2', '--color-text-2'],
  ['text3', '--color-text-3'],
  ['accent', '--color-accent'],
  ['accentSoft', '--color-accent-soft'],
  ['success', '--color-success'],
  ['successSoft', '--color-success-soft'],
  ['warn', '--color-warn'],
  ['warnSoft', '--color-warn-soft'],
  ['danger', '--color-danger'],
  ['dangerSoft', '--color-danger-soft'],
];

export function applyCssVars(tokens: TokenSet): void {
  const root = document.documentElement;
  for (const [key, varName] of colorVarMap) {
    root.style.setProperty(varName, hexToRgbTriplet(tokens.color[key]));
  }
  root.style.setProperty('--font-sans', tokens.font.sans);
  root.style.setProperty('--font-mono', tokens.font.mono);
  root.style.setProperty('--radius-sm', `${tokens.radius.sm}px`);
  root.style.setProperty('--radius-md', `${tokens.radius.md}px`);
  root.style.setProperty('--radius-lg', `${tokens.radius.lg}px`);
}
